import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../components/router/authContext';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/apiConfig';
import { HomeButton } from '../components/website/HomeButton';
import './css/EmailVerificationPage.css';

const EmailVerificationPage = () => {
  const [verificationStatus, setVerificationStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  
  // Add debugging logs
  console.log('EmailVerificationPage rendered');
  console.log('Current URL:', window.location.href);
  console.log('Location object:', location);
  console.log('Pathname:', location.pathname);

  useEffect(() => {
    console.log('Verification useEffect running');
    
    const verifyEmail = async () => {
      console.log('verifyEmail function called');
      
      // Extract token from URL path
      // The pathname will be something like "/verify-email/TOKEN"
      const pathParts = location.pathname.split('/');
      const token = pathParts[pathParts.length - 1]; // Get the last part of the path
      
      console.log('Token from URL path:', token);
      
      if (!token || token === 'verify-email') {
        console.log('No valid token found in URL path');
        setVerificationStatus('error');
        setErrorMessage('Verification token is missing');
        return;
      }

      try {
        console.log('Making API request to verify email with token:', token);
        // Call the verification API
        const response = await axios.post(API_ENDPOINTS.verifyEmail, { token });
        console.log('API response:', response.data);
        
        // Handle success
        setVerificationStatus('success');
      } catch (error) {
        console.error('Email verification API error:', error);
        // Handle error
        setVerificationStatus('error');
        setErrorMessage(
          error.response?.data?.error || 
          'Failed to verify email. Please try again or contact support.'
        );
      }
    };

    // Call the verification function
    verifyEmail();
  }, [location.pathname]); // Changed dependency to location.pathname

  // Log when verification status changes
  useEffect(() => {
    console.log('Verification status changed to:', verificationStatus);
  }, [verificationStatus]);

  return (
    <div className="email-verification-container">
      <div className="email-verification-card">
        <HomeButton />
        
        {verificationStatus === 'verifying' && (
          <div className="verification-loading">
            <div className="spinner"></div>
            <p>Verifying your email address...</p>
          </div>
        )}
        
        {verificationStatus === 'success' && (
          <div className="verification-success">
            <div className="success-icon">✓</div>
            <h2>Email Verified Successfully!</h2>
            <p>Your email has been verified. You can safely close this tab.</p>
          </div>
        )}
        
        {verificationStatus === 'error' && (
          <div className="verification-error">
            <div className="error-icon">✗</div>
            <h2>Verification Failed</h2>
            <p>{errorMessage}</p>
            <p>Please try again or contact support.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationPage; 